import React, { memo } from 'react';
import { Images } from '../../../../../../shared/app-constants';
import EmptyList from '../../../../../../shared/design-system/components/molecules/empty-list/empty-list';

const CallLogsEmptyState: React.FC = () => (
  <div className="call-logs-empty-state d-flex justify-content-center align-items-center">
    <EmptyList
      title="No call activity yet"
      description="Your recent calls will appear here once you start making or receiving calls."
      imgSrc={Images.DialerCallLogsEmpty}
      isVertical
    />
  </div>
);

export default memo(CallLogsEmptyState);
